<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  height: 100vh;
  overflow: hidden;
}

/* 小程序 H5 打印预览页：允许整页滚动，避免内容被裁切 */
#app.mp-print-app {
  height: auto;
  min-height: 100vh;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

#app.site-home-app {
  height: auto;
  min-height: 100vh;
  overflow: visible;
}

body.mp-print-body {
  overflow: auto;
}

@media screen and (max-width: 768px) {
  .el-table {
    font-size: 12px;
  }

  .el-table th,
  .el-table td {
    padding: 8px 0;
  }

  .el-card {
    margin-bottom: 10px;
  }

  .el-card__header {
    padding: 12px;
  }

  .el-card__body {
    padding: 12px;
  }

  .el-button--mini {
    padding: 5px 8px;
    font-size: 12px;
  }

  .el-dialog {
    width: 95% !important;
    margin-top: 5vh !important;
  }

  .el-dialog__body {
    max-height: 60vh;
    overflow-y: auto;
  }

  .el-form-item__label {
    width: 100px !important;
    font-size: 13px;
  }

  .el-form-item__content {
    margin-left: 100px !important;
  }
}
</style>
